import React from 'react';

import styled from 'styled-components';

import useContactsFiltersSummary from '@components/ContactsSelector/Common/UseContactsFiltersSummary';
import NwIcon from '@components/Gui/NwIcon';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    min-width: 0;

    .active-list {
        display: flex;
        align-items: baseline;
        gap: 0.5rem;
        min-width: 0;

        .list-type {
            font-size: ${(props) => props.theme.FontSizeXSm};
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: ${(props) => props.theme.TextColorMuted};
            white-space: nowrap;
        }

        .list-name {
            font-size: ${(props) => props.theme.FontSizeSm};
            font-weight: bold;
            color: ${(props) => props.theme.TextColor};
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .active-filters {
        display: flex;
        flex-wrap: wrap;
        gap: 0.25rem;

        .chip {
            font-size: ${(props) => props.theme.FontSizeXSm};
            text-transform: uppercase;
            color: ${(props) => props.theme.TextColorMuted};
            background: ${(props) => props.theme.BackgroundColorLight};
            border: ${(props) => props.theme.DefaultBorder};
            border-radius: 10px;
            padding: 0.1rem 0.5rem;
        }
    }
`;

/**
 * Riepilogo di cosa è attualmente selezionato: tipo di visualizzazione (selezione rapida,
 * smart list, cartella, progetto) e filtri attivi, sia quick filters che filtri della smart list.
 * Serve a capire cosa è impostato senza riaprire il pannello dei filtri.
 */
const ContactsFiltersActiveSummary = ({ onClick }) => {
    const { listTypeInfo, listName, chips } = useContactsFiltersSummary();

    return (
        <Wrapper onClick={onClick}>
            <div className="active-list">
                <NwIcon icon={listTypeInfo.icon} />
                <span className="list-type">{listTypeInfo.label}</span>
                {listName && <span className="list-name">{listName}</span>}
            </div>
            {chips.length > 0 && (
                <div className="active-filters">
                    {chips.map((chip, index) => (
                        <span className="chip" key={`${chip}-${index}`}>
                            {chip}
                        </span>
                    ))}
                </div>
            )}
        </Wrapper>
    );
};

export default ContactsFiltersActiveSummary;
